import { lazy } from 'react';

export const CalculationPrices = lazy(() =>
    import('./CalculationPrices').then((module) => ({ default: module.CalculationPrices })),
);
